






































import {Component, Prop, Vue} from 'vue-property-decorator'
import {payStatusMap} from '@/utils/status-map'

@Component
export default class StatusEffective extends Vue {
    statusMap = payStatusMap
    @Prop() payStatus!: number
}
